import { WoongarantInsurance } from "@/app/woongarant-insurance/entities/woongarant-insurance.entity"

export interface WoongarantInsuranceState {
    woongarantInsurances: WoongarantInsurance[]
}

export const state: WoongarantInsuranceState = {
    woongarantInsurances: []
}
